import { defineComponent as t, openBlock as r, createBlock as i, unref as n, mergeProps as l } from "vue";
import o from "./ghl-ui.es362.js";
const d = t({
  name: "UISkeleton",
  inheritAttrs: !1
}), u = t({
  ...d,
  props: {
    text: {
      type: Boolean,
      default: !0
    },
    repeat: {
      type: Number,
      default: 1
    },
    width: {
      type: [String, Number],
      default: void 0
    },
    height: {
      type: [String, Number],
      default: void 0
    },
    animated: {
      type: Boolean,
      default: !0
    },
    circle: {
      type: Boolean,
      default: !1
    }
  },
  setup(e) {
    return (a, c) => (r(), i(n(o), l(a.$attrs, {
      text: e.text,
      repeat: e.repeat,
      width: e.width,
      height: e.height,
      animated: e.animated,
      circle: e.circle
    }), null, 16, ["text", "repeat", "width", "height", "animated", "circle"]));
  }
}), h = u;
export {
  h as default
};
